<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Veículo Bloqueado"
        size="lg"
        @close="clean"
    >
        <template v-slot:content>
            <div class="row">
                <!-- Imagem do Veículo -->
                <div class="col-md-5">
                    <ImageVehicle :vehicle-data="vehicleData"/>
                </div>

                <div class="col-md-7">
                    <div class="vehicle-info-container">
                        <SectionContainer
                            title="Dados do Veículo"
                            icon="car-alt"
                        >
                            <div class="vehicle-data">
                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-car-side"></i>
                                        Veículo:
                                    </div>
                                    <div class="data-value">
                                        {{ vehicleData.description }} {{ vehicleData.color }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-hashtag"></i>
                                        Placa:
                                    </div>
                                    <div class="data-value plate">
                                        {{ vehicleData.board }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-tachometer-alt"></i>
                                        Km do Veículo:
                                    </div>
                                    <div class="data-value km-value">
                                        {{ formatKilometers(vehicleData.current_km) }}
                                    </div>
                                </div>
                            </div>
                        </SectionContainer>
                    </div>
                </div>
            </div>

            <!-- Histórico de Viagens -->
            <LastTripsTable
                :vehicle-data="vehicleData"
                :total-trips="totalTrips"
                :pagination-options="paginationOptions"
                @open-trip-details="openTripDetails"
                @load-page="loadPage"
            />
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../Base/BaseModal.vue';
import SectionContainer from "./Checklist/SectionContainer.vue";
import LastTripsTable from "./Components/LastTripsTable.vue";
import ImageVehicle from "./Components/ImageVehicle.vue";

export default {
    name: "BlockedVehicleModal", // Nome do componente: Modal de Veículo Bloqueado
    components: {
        ImageVehicle,
        SectionContainer,
        LastTripsTable,
        BaseModal
    },
    props: {
        modalStatus: { // modalStatus - status do modal se está aberto ou fechado
            type: Boolean,
            default: false
        },
        dataModal: { // dataModal - dados do veículo a serem exibidos no modal
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            paginationOptions: { // paginationOptions - opções de configuração da paginação
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                page: 1,
                chunk: 4,
                chunksNavigation: "fixed",
            }
        };
    },
    computed: {
        vehicleData() { // vehicleData - dados do veículo computados a partir do dataModal
            return this.dataModal || {};
        },
        totalTrips() { // totalTrips - total de viagens para controle da paginação
            return this.dataModal && this.dataModal.lastTrips ? this.dataModal.lastTrips.total : 0;
        }
    },
    methods: {
        formatKilometers(value) { // formatKilometers - formata o valor de quilometragem com pontos
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        openTripDetails(trip) { // openTripDetails - abre os detalhes de uma viagem específica
            this.$emit('OMDCk', trip);
            this.clean();
        },
        loadPage(page) { // loadPage - carrega uma página específica da paginação
            this.$emit('openModals', this.vehicleData.id, this.vehicleData.status, this.vehicleData, page);
        },
        clean() { // clean - limpa e fecha o modal
            this.$emit('changeModal', false);
        }
    }
};
</script>

<style scoped>
.vehicle-info-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.vehicle-data {
    background-color: #f8f9fa;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 15px;
}

.data-row {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
}

.data-row:last-child {
    margin-bottom: 0;
}

.data-label {
    width: 120px;
    font-weight: 600;
    color: #495057;
}

.data-label i {
    width: 18px;
    color: #f8981d;
    margin-right: 5px;
}

.data-value {
    flex: 1;
    padding-left: 10px;
}

.plate {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 3px 8px;
    font-weight: bold;
    display: inline-block;
}

.km-value {
    font-weight: bold;
    color: #0056b3;
}

@media (max-width: 767px) {
    .data-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .data-label {
        width: 100%;
        margin-bottom: 5px;
    }

    .data-value {
        padding-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/LockedModal.vue